/**
 * WeekBanner - Displays current week information
 * Shows week emoji, name, header text, and date range
 */
import { useCopy } from '../lib/copy';

export default function WeekBanner({ week, mode = 'full' }) {
  const t = useCopy();
  if (!week) return null;
  const isSmallSurface = mode === 'compact' || mode === 'mobile';
  const isMobileSurface = mode === 'mobile';

  if (isSmallSurface) {
    return (
      <div className="pb-4">
        <div className="min-w-0">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400 flex items-center gap-1.5">
            {t('Spotlight')}
            <span
              className="tf-cursor inline-block rounded-sm bg-yellow-400"
              style={{
                width: '7px',
                height: '2px',
                alignSelf: 'flex-end',
                marginBottom: '3px',
                boxShadow: '0 1px 4px rgba(234,179,8,0.5)',
              }}
            />
          </p>
          <div className="mt-1 flex items-center gap-2">
            <h2 className="min-w-0 text-[1.15rem] font-semibold leading-tight tracking-[-0.02em] text-slate-900">
              {week.name}
            </h2>
            <span className="shrink-0 text-[1.2rem]" aria-hidden="true">
              {week.emoji}
            </span>
          </div>
          <p className="mt-1.5 max-w-[30rem] text-[13px] leading-6 text-slate-600">{week.header}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-[24px] border border-slate-200/80 bg-gradient-to-br from-indigo-50 to-slate-50 p-7 sm:p-10">
      <div className="flex items-center gap-4">
        <div className="text-4xl sm:text-5xl" aria-hidden="true">
          {week.emoji}
        </div>

        <div className="flex-1">
          <h2 className="mb-1 text-xl font-semibold text-slate-900 sm:text-2xl">{week.name}</h2>
          <p className="text-sm text-slate-600 sm:text-base">{week.header}</p>
        </div>
      </div>
    </div>
  );
}
